import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import DashboardContainer from "../../../containers/admin";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import Header from "../../../components/admin/header";
import group125 from "../../../assets/admin/Group 125.svg";
import group126 from "../../../assets/admin/Group 126.svg";
import group127 from "../../../assets/admin/Group 127.svg";
import group1272 from "../../../assets/admin/Group 127-2.svg";
import api from "../../../utils/apiConfig";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { jwtDecode } from "jwt-decode";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-black text-white text-sm px-3 py-1 rounded-lg">
        ₦{payload[0].value.toLocaleString()}
      </div>
    );
  }
  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};

const AdminDashboard = () => {
  const [chartData, setChartData] = useState([]);
  const [users, setUsers] = useState([]);
  const [plans, setPlans] = useState({});
  const [revenue, setRevenue] = useState(0);
  const [balance, setBalance] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      navigate("/twzpanel");
      toast.error("You need to login first");
    } else {
      const { exp } = jwtDecode(token);
      if (Date.now() >= exp * 1000) {
        navigate("/twzpanel");
        toast.error("Your session has expired. Please login again");
      }
    }
  }, [navigate]);

  useEffect(() => {
    api.get("/admin/users")
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    api.get("/admin/users/plans")
      .then((res) => {
        setPlans(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    api.get("/admin/revenue")
      .then((res) => {
        setRevenue(res.data.revenue);

        const bronzeUsers = res.data.bronzeUsers;
        const vipUsers = res.data.vipUsers;

        const data = [
          { name: "Bronze", value: bronzeUsers * 5000 },
          { name: "VIP", value: vipUsers * 10000 },
        ];

        setChartData(data);
      })
      .catch((err) => {
        console.log(err);
      });

    api.get("/admin/balance")
      .then((res) => {
        setBalance(res.data.total);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <DashboardContainer>
      <Header title="Dashboard" />

      <div className="bg-white p-10 rounded-xl shadow-md mb-6 grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="flex items-center space-x-4">
          <img src={group125} className="h-14 w-14" alt="Users" />
          <div>
            <h2 className="text-sm font-light text-gray-400">Users</h2>
            <p className="text-2xl font-bold">
              {users.length ? users.length : "0"}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <img src={group126} className="h-14 w-14" alt="Balance" />
          <div>
            <h2 className="text-sm font-light text-gray-400">Balance</h2>
            <p className="text-2xl font-bold">
              <span className="text-gray-400">₦</span>
              {balance.toLocaleString()}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <img src={group127} className="h-14 w-14" alt="Plans" />
          <div>
            <h2 className="text-sm font-light text-gray-400">Plans</h2>
            <p className="text-2xl font-bold">
              {Object.keys(plans).length ? Object.keys(plans).length : "0"}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-md mb-6">
        <div className="flex items-center space-x-3">
          <img src={group1272} className="h-8 w-8" alt="Plans" />
          <h2 className="text-sm font-semibold text-secondary">Monthly Revenue</h2>
        </div>
        <p className="text-4xl font-light mt-2"><span className="text-gray-400">₦</span>{revenue}</p>

        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={chartData}>
            <CartesianGrid vertical={false} strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fill: "#d1d5db", fontSize: 12 }} axisLine={false} tickLine={false} />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />
            <Bar dataKey="value" radius={[5, 5, 0, 0]} fill="#4F46E5" barSize={20} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      
    </DashboardContainer>
  );
};

export default AdminDashboard;
